import { Loader } from '@googlemaps/js-api-loader';
import CmsApi from "../util/CmsApi";

export default class ThingsToDo {

	static getHolderSelectors = () => ['.things-to-do-element'];

	static ALL_CATEGORIES = 0;

	/** @type {HTMLElement} */
	#holderElement;
	/** @type {object} */
	#property;
	/** @type {object[]} */
	#places;
	/** @type {google.maps.Map} */
	#map;
	/** @type {Loader} */
	#loader;
	/** @type {google.maps.MapsLibrary} */
	#mapsLibrary;
	/** @type {google.maps.CoreLibrary} */
	#coreLibrary;
	/** @type {google.maps.MarkerLibrary} */
	#markerLibrary;


	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#loader = new Loader({
			apiKey: window.config.googleMapsApiKey,
			version: 'weekly',
		});
		this.#initMap();
	}

	async #initMap() {
		this.#mapsLibrary = await this.#loader.importLibrary('maps');
		this.#coreLibrary = await this.#loader.importLibrary('core');
		this.#markerLibrary = await this.#loader.importLibrary('marker');

		this.#map = new this.#mapsLibrary.Map(this.#holderElement.querySelector('.map'), {
			zoom: 8,
			center: { lat: -34.397, lng: 150.644 },
			disableDefaultUI: true,
			maxZoom: 15,
			zoomControl: true,
			mapTypeId: 'terrain',
		});


		await Promise.all([
			CmsApi.fetchProperty(this.#holderElement.dataset.propertySlug),
			CmsApi.fetchPropertyPlaces(this.#holderElement.dataset.propertySlug),
			await window.loadScript('snazzyInfoWindow'),
		]).then(values => {
			this.#property = values[0];
			this.#places = values[1];
		});

		this.#property.marker = new this.#markerLibrary.Marker({
			position: {lat: this.#property.address.latitude, lng: this.#property.address.longitude},
			map: this.#map,
			title: this.#property.name,
			icon: {
				url: this.#property.mapPin ?? window.config.themeDirectory + '/img/map-pin.svg',
				scaledSize: {width: 50, height: 50, widthUnit: 'px', heightUnit: 'px'},
			},
			zIndex: this.#markerLibrary.Marker.MAX_ZINDEX,
		});
		this.#property.infoWindow = new SnazzyInfoWindow({
			marker: this.#property.marker,
			content: `<h4>${this.#property.name}</h4><p>${this.#property.address.address}</p>`,
			closeWhenOthersOpen: true,
			showCloseButton: false,
		});


		this.#places.forEach(p => {
			const location = {lat: p.latitude, lng: p.longitude};
			p.marker = new this.#markerLibrary.Marker({
				position: location,
				map: this.#map,
				title: p.name,
				icon: window.config.themeDirectory + '/img/map-pin.svg',
			});
			p.infoWindow = new SnazzyInfoWindow({
				marker: p.marker,
				content: [
					`<h4>${p.name}</h4><p>${p.address}</p>`,
					p.website ? `<a href="${p.website}" target="_blank">website</a>` : '',
				].join(''),
				closeWhenOthersOpen: true,
				showCloseButton: false,
			});
		});

		this.#filterCategories(ThingsToDo.ALL_CATEGORIES);


		const controlsElement = this.#holderElement.querySelector('.category-controls');

		const all = '<button type="button" class="btn selected" data-category-id="0">All</button>'
		const added = [];
		controlsElement.innerHTML = all + this.#places
			.flatMap(p => p.categories)
			.filter(p => {
				if (added.includes(p.id)) {
					return false;
				}
				return added.push(p.id);
			})
			.map(p => `<button type="button" class="btn" data-category-id="${p.id}">${p.name}</button>`)
			.join('');
		const buttons = controlsElement.querySelectorAll('button');
		buttons.forEach(btn =>
			btn.addEventListener('click', (e) => {
				this.#filterCategories(parseInt(e.currentTarget.dataset.categoryId));
				buttons.forEach(b => b.classList.remove('selected'));
				btn.classList.add('selected');
			})
		);
	}

	#filterCategories = (id) => {
		const bounds = new this.#coreLibrary.LatLngBounds();
		this.#places.forEach(p => {
			const show = id === ThingsToDo.ALL_CATEGORIES || !!p.categories.find(c => c.id === id);
			p.marker.setMap(show ? this.#map : null);
			p.infoWindow.close();
			show && bounds.extend(p.marker.position);
		});
		this.#map.fitBounds(bounds);
	};

}
